
document.documentElement.classList.remove('no-js');

document.addEventListener('click', function (event) {
  const toggle = event.target.closest('[data-mobile-menu-toggle]');
  if (toggle) {
    const menu = document.querySelector('[data-mobile-menu]');
    if (menu) {
      const open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }
});

document.addEventListener('change', function(event){
  const select = event.target.closest('[data-sort-by]');
  if (!select) return;
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', select.value);
  window.location.href = url.toString();
});
